import {Fragment, useContext} from 'react';

import {HomeNavigator, LoadingNavigator} from 'navigators';
import {getDisplay} from 'utils';
import {LoadPercentage} from 'context';

const App: React.FC = () => {
  const {isReady} = useContext(LoadPercentage.Context);

  return (
    <Fragment>
      <LoadingNavigator display={getDisplay(!isReady)} />
      <HomeNavigator display={getDisplay(isReady)} />
    </Fragment>
  );
};

export default App;
